import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row, Modal, Button } from "react-bootstrap";
import { Spin } from "antd";
import CustomSelect from "../../../CustomControls/CustomSelect";

import { post } from "../../../helpers/api_helper";
import { delete_RecordWithoutApi, warningMessage } from "../CommonFunctions";
import {
  dataUrlToFile,
  dataUrlToFileUsingFetch,
} from "../../../CustomControls/Utils";
import img200 from "../../../../images/avatar/DefaultUserPhoto.jpg";

import { useRef } from "react";
import Webcam from "react-webcam";
import {
  POST_DDLGetTestMasterByInwardMaterialID,
  POST_GetCustomerDDLList,
  POST_GetTestingsDetailByID,
  POST_GetTestingsInwardMaterialDetailByID,
  POST_GetCameraDropDownListByCompanyID,
  POST_GetNDTCategoryDropDownListByCategoryType,
  POST_GetMPTMaterialDropDownListByCompanyID,
} from "../../../helpers/url_helper";
import { SVGICON } from "../../../constant/theme";
import NDTProcessTypeRT from "./NDTProcessTypeRT";
import NDTProcessTypeUT from "./NDTProcessTypeUT";
import NDTProcessTypeMT from "./NDTProcessTypeMT";
import NDTProcessTypePT from "./NDTProcessTypePT";

const AddTestingNDT = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { InwardMaterialIDParam, InwardMaterialTestDetailIDParam } =
    useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [showLetterRefDocModal, setShowLetterRefDocModal] = useState(false);

  const [testMethodOptions, setTestMethodOptions] = useState([]);
  const [testMasterOptions, setTestMasterOptions] = useState([]);

  const webcamRef = useRef(null);

  const videoConstraints = {
    width: 600,
    height: 600,
    facingMode: "environment",
  };

  const locationTypeOptions = [
    { label: "Permanent Facility", value: 1 },
    { label: "On Site", value: 2 },
  ];

  const validationSchema = Yup.object().shape({
    InwardMaterialTestDetailIDEncrypt: Yup.string().required(
      "Test Name is required field"
    ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      TestMasterIDEncrypt: "",
      InwardMaterialIDEncrypt: InwardMaterialIDParam
        ? window.atob(InwardMaterialIDParam)
        : "",
      TestingIDEncrypt: "",
      InwardIDEncrypt: "",
      InwardMaterialTestDetailIDEncrypt: InwardMaterialTestDetailIDParam
        ? window.atob(InwardMaterialTestDetailIDParam)
        : "",
      InwardNo: "",
      InwardDate: "",
      ExpectedDateOfDelivery: "",
      InwardMaterialID: "",
      TestName: "",
      // TestingDate: new Date(),
      // TestingToDate: new Date(),
      // TestingQty: "",
      // InvoiceQty: "",
      // UnitID: "",
      // TestMethodIDEncrypt: "",
      // TestingByID: "",
      // ReferenceStandardIDEncrypted: "",
      // MachineIDEncrypt: "",
      // ParameterWith: 1,
      // IsMergeSameValue: false,
      // ReferenceSubGroup: "",
      // Result: "",
      // Remarks: "",
      // ChangeNote: "",
      TestingStatus: 0,
      LetterRefNo: "",
      SampleNote: "",
      IsMaterialReturnable: false,
      IsTPIRequired: true,
      ListOfLetterRefDoc: [],
      ListOfTPIDetails: [],
      // ListTestingResultImages: [],
      // ListTestMasterImages: [],
      TCNo: "",
      DepartmentIDEncrypt: "",
      DepartmentName: "",
      // ProductGroupIDEncrypt: "",
      // ProductGroupName: "",
      // MaterialTypeName: "",
      // MaterialTypeIDEncrypt: "",
      // SampleDetail: "",
      // searchTestingBy: "",
      // ListTestingBy: [],
      // Condition: "",
      // Size: "",
      // CustomerProjectIDEncrypted: "",
      btnSubmitType: 1,
      IsNABLRangeChange: false,
      IsReTestTesting: false,
      // TestName: "",
      // TestingDateDisplay: "",
      // TestingToDateDisplay: "",
      // MachineName: "",
      // UnitName: "",
      // TestMethodName: "",
      // ReferenceStandardName: "",
      AllowTestingEdit: 0,
      IsDefaultLoad: false,
      // LocationType: 0,
      // IsDefaultLoadCalculateAverage: false,
      // BasedOnMeasurementValue: "",
      // BasedOnHrsValue: "",
      IsNDT: false,
      // Location: "",
      // DieNo: "",
      // HeatNo: "",
      // DRGNo: "",
      // Thikness: "",
      // AreatoBeCovered: "",
      // RadiationEnergy: "",
      // Density: "",
      // Sensitivity: "",
      TestType: 1,
      NDTProcessType: 0,
      // AcceptanceStandardName: "",
      // AcceptanceStandardEncrypted: "",
      // TestCarriedOutat: "",
      // RTCoverage: "",
      // LeadThiknessFront: "",
      // LeadThiknessBack: "",
      // Technique: "",
      // AdditionsToDeviations: "",
      // WeldingProcess: "",
      // CameraIDEncrypted: "",
      // SourceStrength: "",
      // SourceSize: "",
      // RediationSource: "",
      // ExposureTime: "",
      // FilmBrand: "",
      // Viewing: "",
      // ProcessingTime: "",
      // Screen: "",
      // XRayKV: "",
      // ListOfTestingParameters: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InwardMaterialIDEncrypt,
      TestMasterIDEncrypt,
      InwardMaterialTestDetailIDEncrypt,
      InwardNo,
      InwardDate,
      ExpectedDateOfDelivery,
      LetterRefNo,
      SampleNote,
      IsMaterialReturnable,
      IsTPIRequired,
      ListOfLetterRefDoc,
      ListOfTPIDetails,
      TCNo,
      DepartmentName,
      TestingStatus,
      IsReTestTesting,
      TestingDate,
      TestingToDate,
      AllowTestingEdit,
      IsNDT,
      Location,
      NDTProcessType,
      ListOfTestingParameters,
    },
  } = formik;

  useEffect(() => {
    if (TestingToDate && TestingToDate < TestingDate) {
      formik.setFieldValue("TestingToDate", TestingDate);
    }
    //getTestMethodDDLList();
  }, [TestingDate]);

  const handleValidSubmit = (values) => {
    // alert(1111);
  };

  useEffect(() => {
    getTestMasterDDLInwardMaterialWise();
    // getUnitDDL();
    getCustomerDDL();
    //getTestingRemarksList();
    GetNDTCategoryDropDownListByCategoryTypeApi();
    GetFindingsDropDownList();
    GetProcedureDropDownList();
    getCameraDDL();
    GetMPTMaterialDropDownList();
    if (InwardMaterialIDParam && !InwardMaterialTestDetailIDParam) {
      getTestingInwardMaterialDetailByID();
    }

    if (InwardMaterialTestDetailIDParam) {
      getTestingDetailByID(InwardMaterialTestDetailIDEncrypt);
    }
  }, []);

  const handleKeyDownDisable = (event) => {
    if (AllowTestingEdit != 1) {
      event.preventDefault(); // Prevent key action
    }
  };

  const GetMPTMaterialDropDownList = async () => {
    setIsLoading(true);
    await post(POST_GetMPTMaterialDropDownListByCompanyID, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "MPTMaterialOptions",
            response?.List?.map((item) => ({
              label: item.MPTMaterial,
              value: item.MPTMaterialIDEncrypt,
              ManufacturerOfPowder: item?.ManufacturerOfPowder,
              BatchNo: item?.BatchNo,
              ManufacturerDate: item?.ManufacturerDate,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const GetNDTCategoryDropDownListByCategoryTypeApi = async () => {
    setIsLoading(true);
    await post(POST_GetNDTCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      NDTCategoryType: 1, // 1 is for Sensitivity
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "sensitivityOptions",
            response?.List?.map((item) => ({
              label: item.NDTCategoryName,
              value: item.NDTCategoryID,
            }))
          );
          //   setWastageReasonList(
          //     response?.List?.map((x) => ({
          //       label: x.NDTCategoryName,
          //       value: x.NDTCategoryID,
          //     }))
          //   );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const GetFindingsDropDownList = async () => {
    setIsLoading(true);
    await post(POST_GetNDTCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      NDTCategoryType: 2, // 2 is for Findings
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "findingsOptions",
            response?.List?.map((item) => ({
              label: item.NDTCategoryName,
              value: item.NDTCategoryID,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const GetProcedureDropDownList = async () => {
    setIsLoading(true);
    await post(POST_GetNDTCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      NDTCategoryType: 3, // 3 is for Procedure
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ProcedureOptions",
            response?.List?.map((item) => ({
              label: item.NDTCategoryName,
              value: item.NDTCategoryID,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCameraDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCameraDropDownListByCompanyID, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "cameraOptions",
            response?.List?.map((item) => ({
              label: item.ModelNo + "-" + item?.SerialNo,
              value: item.CameraIDEncrypt,
              SourceSize: item?.SourceSize,
              SerialNo: item?.SerialNo,
              Isotope: item?.Isotope,
            }))
          );
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // setIsLoading(false);
      });
  };

  const getCustomerDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      //TPIFlag: -1, // -1 = All (Customer & TPI both)
      TPIFlag: 1, // 1 = TPI Only
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "tpiCustomerOptions",
            response?.CustomerDDLList?.filter((x) => x.IsTPI == true)?.map(
              (item) => ({
                label: item.CustomerName,
                value: item.CustomerIDEncrypted,
              })
            )
          );
          //   setTPICustomerOptions(
          //     response?.CustomerDDLList?.filter((x) => x.IsTPI == true)?.map(
          //       (item) => ({
          //         label: item.CustomerName,
          //         value: item.CustomerIDEncrypted,
          //       })
          //     )
          //   );
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // setIsLoading(false);
      });
  };

  const getTestMasterDDLInwardMaterialWise = async () => {
    setIsLoading(true);
    await post(POST_DDLGetTestMasterByInwardMaterialID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InwardMaterialIDEncrypted: InwardMaterialIDEncrypt,
      EmployeeIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTestMasterOptions(
            response?.List?.map((item) => ({
              label: item.TestName,
              value: item.InwardMaterialTestDetailIDEncrypted,
              //TestingStatusDDL: item.TestingStatus,
              AllowTestingEdit: item?.AllowTestingEdit,
            }))
          );

          // if (response?.List?.length == 1) {
          //   formik.setFieldValue(
          //     "InwardMaterialTestDetailIDEncrypt",
          //     response?.List[0].InwardMaterialTestDetailIDEncrypted
          //   );
          // }
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // setIsLoading(false);
      });
  };

  const getTestingInwardMaterialDetailByID = async () => {
    setIsLoading(true);
    await post(POST_GetTestingsInwardMaterialDetailByID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InwardMaterialIDEncrypted: InwardMaterialIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          //Set Details

          formik.setFieldValue("InwardIDEncrypt", response?.InwardIDEncrypt);
          formik.setFieldValue(
            "CustomerProjectIDEncrypted",
            response?.CustomerProjectIDEncrypt
          );
          formik.setFieldValue("InwardNo", response?.InwardNo);
          formik.setFieldValue("InwardDate", response?.InwardDate);
          formik.setFieldValue(
            "ExpectedDateOfDelivery",
            response?.ExpectedDateOfDelivery
          );
          formik.setFieldValue(
            "IsMaterialReturnable",
            response?.IsMaterialReturnable
          );
          formik.setFieldValue("IsTPIRequired", response?.IsTPIRequired);
          formik.setFieldValue("LetterRefNo", response?.LetterRefNo);
          formik.setFieldValue("TCNo", response?.TCNo);
          formik.setFieldValue("IsNDT", response?.IsNDT);

          formik.setFieldValue(
            "ListOfLetterRefDoc",
            response?.ImagesList?.map((item) => ({
              InwardLetterRefImageIDEncrypted:
                item.InwardLetterRefImageIDEncrypt,
              LetterRefImageFile: "",
              viewFile: "",
              LetterRefImageFileName: item?.LetterRefImageFileName,
              LetterRefImageFilePath: item.LetterRefImageFilePath,
              IsDeleted: false,
            }))
          );

          formik.setFieldValue(
            "ListOfTPIDetails",
            response?.TPIList?.map((x) => {
              return {
                ...x,
                TPIIDEncrypted: x?.TPIIDEncrypt,
                TPIContactPersonIDEncrypted: x?.TPIContactPersonIDEncrypt,
                TPIExpectedDate: x?.TPIExpectedDate
                  ? new Date(x?.TPIExpectedDate)
                  : "",
                displayTPIExpectedDate: x?.TPIExpectedDate,
                IsDeleted: false,
              };
            })
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTestingDetailByID = async (inwardMaterialTestDetailID) => {
    setIsLoading(true);
    await post(POST_GetTestingsDetailByID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InwardMaterialIDEncrypted: InwardMaterialIDEncrypt,
      InwardMaterialTestDetailIDEncrypted: inwardMaterialTestDetailID,
      TranDate: "",
      EmployeeIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "AllowTestingEdit",
            response?.AllowTestingEdit ?? 0
          );
          formik.setFieldValue(
            "TestMasterIDEncrypt",
            response?.TestMasterIDEncrypt
          );
          formik.setFieldValue("TestingIDEncrypt", response?.TestingIDEncrypt);
          formik.setFieldValue("InwardIDEncrypt", response?.InwardIDEncrypt);
          formik.setFieldValue(
            "CustomerProjectIDEncrypted",
            response?.CustomerProjectIDEncrypt
          );
          formik.setFieldValue("InwardNo", response?.InwardNo);
          formik.setFieldValue("InwardDate", response?.InwardDate);
          formik.setFieldValue(
            "ExpectedDateOfDelivery",
            response?.ExpectedDateOfDelivery
          );
          formik.setFieldValue(
            "IsMaterialReturnable",
            response?.IsMaterialReturnable
          );
          formik.setFieldValue("IsTPIRequired", response?.IsTPIRequired);
          formik.setFieldValue("LetterRefNo", response?.LetterRefNo);
          formik.setFieldValue(
            "ListOfLetterRefDoc",
            response?.ImagesList?.map((item) => ({
              InwardLetterRefImageIDEncrypted:
                item.InwardLetterRefImageIDEncrypt,
              LetterRefImageFile: "",
              viewFile: "",
              LetterRefImageFileName: item?.LetterRefImageFileName,

              LetterRefImageFilePath: item.LetterRefImageFilePath,
              IsDeleted: false,
            }))
          );
          formik.setFieldValue("TCNo", response?.TCNo);

          formik.setFieldValue("IsNDT", response?.IsNDT);

          formik.setFieldValue("TestType", response?.TestType);
          formik.setFieldValue("NDTProcessType", response?.NDTProcessType);

          formik.setFieldValue(
            "DepartmentIDEncrypt",
            response?.TestDetails[0]?.DepartmentIDEncrypt
          );
          formik.setFieldValue(
            "DepartmentName",
            response?.TestDetails[0]?.DepartmentName
          );

          formik.setFieldValue(
            "SampleNote",
            response?.TestDetails[0]?.TestNote
          );

          formik.setFieldValue("IsReTestTesting", response?.IsReTestTesting);

          // setTestMethodOptions(
          //   response?.ListOfTestMethod.map((item) => ({
          //     label: item.NickName
          //       ? `${item.TestMethod} (${item.NickName})`
          //       : item.TestMethod,
          //     value: item?.TestMethodIDEncrypted,
          //     IsExpiredTestMethod: item?.IsExpiredTestMethod,
          //   }))
          // );
        } else {
          //Reset Details
          formik.setFieldValue("AllowTestingEdit", 0);
          formik.setFieldValue("TestMasterIDEncrypt", "");
          formik.setFieldValue("TestingIDEncrypt", "");
          formik.setFieldValue("InwardIDEncrypt", "");
          formik.setFieldValue("CustomerProjectIDEncrypted", "");
          formik.setFieldValue("InwardNo", "");
          formik.setFieldValue("InwardDate", "");
          formik.setFieldValue("ExpectedDateOfDelivery", "");
          formik.setFieldValue("IsMaterialReturnable", false);
          formik.setFieldValue("IsTPIRequired", false);
          formik.setFieldValue("LetterRefNo", "");
          formik.setFieldValue("ListOfLetterRefDoc", []);
          formik.setFieldValue("TCNo", "");
          formik.setFieldValue("DepartmentIDEncrypt", "");
          formik.setFieldValue("DepartmentName", "");
          formik.setFieldValue("ProductGroupIDEncrypt", "");
          formik.setFieldValue("ProductGroupName", "");
          formik.setFieldValue("MaterialTypeIDEncrypt", "");
          formik.setFieldValue("MaterialTypeName", "");
          formik.setFieldValue("SampleNote", "");

          formik.setFieldValue("IsMergeSameValue", false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeTest = (e) => {
    formik.setFieldValue("InwardMaterialTestDetailIDEncrypt", e?.value ?? "");
    formik.setFieldValue("AllowTestingEdit", e?.AllowTestingEdit ?? 0);

    getTestingDetailByID(e?.value ?? "");
  };

  const uploadLetterRefDoc = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];

      if (file) {
        formik.setFieldValue("ListOfLetterRefDoc", [
          ...ListOfLetterRefDoc,
          {
            InwardLetterRefImageIDEncrypted: "",
            LetterRefImageFile: file,
            viewFile: URL.createObjectURL(file),
            LetterRefImageFileName: file?.name,
            LetterRefImageFilePath: "",
            IsDeleted: false,
          },
        ]);
      }
    }
  };

  const deleteLetterRefDoc = (i) => {
    if (ListOfLetterRefDoc[i]?.InwardLetterRefImageIDEncrypted) {
      formik.setFieldValue(`ListOfLetterRefDoc[${i}].IsDeleted`, true);
    } else {
      formik.setFieldValue(
        "ListOfLetterRefDoc",
        ListOfLetterRefDoc?.filter((x, ix) => ix != i)
      );
    }
  };

  const [letterRefDocPhoto, setLetterRefDocPhoto] = useState(null);
  const [letterRefDocPhotoFile, setLetterRefDocPhotoFile] = useState(null);
  const [
    openWebCamModalLetterRefDocImage,
    setOpenWebCamModalLetterRefDocImage,
  ] = useState(false);

  const [letterRefDocPhotoFileName, setLetterRefDocPhotoFileName] = useState();

  const addLetterRefDocFile = () => {
    formik.setFieldValue("ListOfLetterRefDoc", [
      ...ListOfLetterRefDoc,
      {
        InwardLetterRefImageIDEncrypted: "",
        LetterRefImageFile: letterRefDocPhotoFile,
        viewFile: URL.createObjectURL(letterRefDocPhotoFile),
        LetterRefImageFileName: letterRefDocPhotoFileName,
        LetterRefImageFilePath: "",
        IsDeleted: false,
      },
    ]);

    setLetterRefDocPhoto(null);
    setLetterRefDocPhotoFile(null);
  };

  const captureLetterRefDocPhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (imageSrc !== null) {
      setLetterRefDocPhoto(imageSrc);
      const outputFileLetterRefDocPhotoCapture = await dataUrlToFileUsingFetch(
        imageSrc,
        "output.png",
        "image/png"
      );
      setLetterRefDocPhotoFile(outputFileLetterRefDocPhotoCapture);
      const fileName = outputFileLetterRefDocPhotoCapture.name;
      setLetterRefDocPhotoFileName(fileName);
    } else {
      warningMessage("Webcam device not found.");
    }
    setOpenWebCamModalLetterRefDocImage(false);
  }, [webcamRef]);

  const onUserMedia = (e) => {
    console.log(e);
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <div className="tbl-caption p-2">
                  <Row>
                    <Col lg={1}>
                      <h4 className="heading">Testing NDT</h4>
                    </Col>
                    <Col lg={5}>
                      <Field
                        name="InwardMaterialTestDetailIDEncrypt"
                        placeholder={"Select Test Name"}
                        component={CustomSelect}
                        options={testMasterOptions}
                        onChange={handleChangeTest}
                        isClearable={false}
                        noMarginBottom={true}
                        autoFocus
                      />
                    </Col>
                  </Row>
                </div>

                <hr className="mt-0 mb-1"></hr>
                <label>Inward Information</label>
                <Row>
                  <Col lg={6}>
                    <div className="card mb-2" style={{ height: "auto" }}>
                      <div className="card-body p-2">
                        <Row>
                          <Col lg={12}>
                            <div className="col-xl-12 col-lg-12">
                              <div className="row">
                                <div className="col-xl-6 col-lg-4">
                                  <div className="">
                                    <ul>
                                      <li>
                                        <label className="mb-1">
                                          Inward No :
                                        </label>
                                        <span className="ms-1">{InwardNo}</span>
                                      </li>

                                      <li>
                                        <label className="mb-1">
                                          Inward Date :
                                        </label>
                                        <span className="ms-1">
                                          {InwardDate}
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-4">
                                  <div className="">
                                    <ul>
                                      <li>
                                        <label className="mb-1">EDD :</label>
                                        <span className="ms-1">
                                          {ExpectedDateOfDelivery}
                                        </span>
                                      </li>
                                      {AuthUser?.Permissions
                                        ?.DispatchMaterial == 1 ? (
                                        <li>
                                          <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 pe-1 mb-1">
                                            <label className="mb-1">
                                              Sample Returnable :
                                            </label>
                                            <span className="ms-1">
                                              {IsMaterialReturnable === true
                                                ? "Yes"
                                                : "No"}
                                            </span>
                                          </text>
                                        </li>
                                      ) : (
                                        ""
                                      )}
                                    </ul>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-4">
                                  <div className="">
                                    <ul>
                                      <li>
                                        <label className="mb-1">
                                          Letter Ref No :
                                        </label>
                                        <span className="ms-1">
                                          {LetterRefNo}&nbsp;&nbsp;
                                        </span>
                                        {AllowTestingEdit == 1 &&
                                        IsReTestTesting == false ? (
                                          ListOfLetterRefDoc?.length > 0 ? (
                                            <Link
                                              to="#"
                                              title="Letter Ref Doc"
                                              className="text-primary"
                                              onClick={() => {
                                                setShowLetterRefDocModal(true);
                                              }}
                                            >
                                              View
                                            </Link>
                                          ) : (
                                            ""
                                          )
                                        ) : (
                                          ""
                                        )}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-4">
                                  <div className="">
                                    <ul>
                                      <li>
                                        <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 pe-1">
                                          <label className="mb-1">
                                            TPI Required :
                                          </label>
                                          <span className="ms-1">
                                            {IsTPIRequired === true
                                              ? "Yes"
                                              : "No"}
                                          </span>
                                        </text>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="card mb-2" style={{ height: "auto" }}>
                      <div className="card-body p-2">
                        <Row>
                          <div className="col-xl-6 col-lg-4">
                            <div className="">
                              <ul>
                                <li>
                                  <label className="mb-1">TC No :</label>
                                  <span className="ms-1">{TCNo}</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-xl-6 col-lg-4">
                            <div className="">
                              <ul>
                                <li>
                                  <label className="mb-1">Department :</label>
                                  <span className="ms-1">{DepartmentName}</span>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="col-xl-12 col-lg-12">
                            <div className="">
                              <ul>
                                <li>
                                  <label className="mb-1">Sample Note :</label>
                                  <span className="ms-1">
                                    {SampleNote}
                                  </span>{" "}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Form>
            </FormikProvider>
            {InwardMaterialTestDetailIDEncrypt && (
              <div
                className={AllowTestingEdit == 1 ? "" : "disableDiv"}
                onKeyDown={handleKeyDownDisable}
              >
                {NDTProcessType == 1 ? (
                  <NDTProcessTypeUT
                    InwardMaterialIDEncrypted={InwardMaterialIDEncrypt}
                    InwardMaterialTestDetailID={
                      InwardMaterialTestDetailIDEncrypt
                    }
                    MainFormik={formik.values}
                  />
                ) : NDTProcessType == 2 ? (
                  <NDTProcessTypeRT
                    InwardMaterialIDEncrypted={InwardMaterialIDEncrypt}
                    InwardMaterialTestDetailID={
                      InwardMaterialTestDetailIDEncrypt
                    }
                    MainFormik={formik.values}
                  />
                ) : NDTProcessType == 3 ? (
                  <NDTProcessTypeMT
                    InwardMaterialIDEncrypted={InwardMaterialIDEncrypt}
                    InwardMaterialTestDetailID={
                      InwardMaterialTestDetailIDEncrypt
                    }
                    MainFormik={formik.values}
                  />
                ) : NDTProcessType == 4 ? (
                  <NDTProcessTypePT
                    InwardMaterialIDEncrypted={InwardMaterialIDEncrypt}
                    InwardMaterialTestDetailID={
                      InwardMaterialTestDetailIDEncrypt
                    }
                    MainFormik={formik.values}
                  />
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        </Spin>

        <Modal
          className="fade"
          show={showLetterRefDocModal}
          onHide={setShowLetterRefDocModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Letter Ref Doc</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowLetterRefDocModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="mb-2">
                    <label></label>
                    <div className="avatar-file">
                      <input
                        type="file"
                        id="LetterRefUpload2"
                        onChange={uploadLetterRefDoc}
                      />
                      <label htmlFor="LetterRefUpload2" name=""></label>
                    </div>
                    <div
                      id="webCam"
                      className="avatar-camera"
                      onClick={() => {
                        setOpenWebCamModalLetterRefDocImage(true);
                      }}
                      style={{ marginLeft: "50px" }}
                    >
                      <input type="hidden" />
                      <label htmlFor="webCam" name=""></label>
                    </div>
                  </div>
                </Col>
                {letterRefDocPhoto && (
                  <Col lg={12}>
                    <div className="d-flex">
                      <div className="image-placeholder companyLogo-placeholder mt-0 ms-0">
                        <div className="avatar-preview">
                          <div id="imagePreview">
                            <img
                              id="saveImageFile"
                              src={
                                letterRefDocPhoto ? letterRefDocPhoto : img200
                              }
                              alt={"Material Image"}
                              style={{
                                maxHeight: "100px",
                                maxWidth: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-primary me-1"
                          onClick={() => {
                            addLetterRefDocFile();
                          }}
                        >
                          <i className="fa fa-cloud-upload"></i> Upload
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => {
                            setLetterRefDocPhoto(null);
                            setLetterRefDocPhotoFile(null);
                          }}
                        >
                          <i className="fa fa-cancel"></i> Cancel
                        </button>
                      </div>
                    </div>
                  </Col>
                )}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="LetterRefDocPhotos-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="LetterRefDocPhotos-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              File Name
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfLetterRefDoc?.filter(
                            (x) => x.IsDeleted == false
                          )?.length > 0 ? (
                            ListOfLetterRefDoc?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                <td style={{ textAlign: "left" }}>
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.LetterRefImageFilePath
                                          ? item.LetterRefImageFilePath
                                          : item.viewFile
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye" />
                                  </Link>
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      delete_RecordWithoutApi(
                                        deleteLetterRefDoc,
                                        indx
                                      );
                                    }}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.LetterRefImageFileName}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {openWebCamModalLetterRefDocImage == true && (
                <div className="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={openWebCamModalLetterRefDocImage}
          onHide={setOpenWebCamModalLetterRefDocImage}
        >
          <Modal.Header>
            <Modal.Title>Letter Ref Doc</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenWebCamModalLetterRefDocImage(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  mirrored={true}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  onUserMedia={onUserMedia}
                  className="webCam"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary btn-sm" onClick={captureLetterRefDocPhoto}>
              <i className="fa fa-camera"></i> Capture
            </Button>

            <Button
              variant="danger btn-sm"
              onClick={() => {
                setOpenWebCamModalLetterRefDocImage(false);
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default AddTestingNDT;
